import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7Progressbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7Progressbar, _React$Component);

  function F7Progressbar(props, context) {
    var _this;

    _classCallCheck(this, F7Progressbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7Progressbar).call(this, props, context));
    _this.__reactRefs = {};
    return _this;
  }

  _createClass(F7Progressbar, [{
    key: "set",
    value: function set(progress, speed) {
      var self = this;
      if (!self.$f7) return;
      self.$f7.progressbar.set(self.refs.el, progress, speed);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var self = this;
      var props = self.props;
      var progress = props.progress,
          id = props.id,
          style = props.style,
          infinite = props.infinite,
          className = props.className;
      var transformStyle = {
        transform: progress ? "translate3d(".concat(-100 + progress, "%, 0, 0)") : '',
        WebkitTransform: progress ? "translate3d(".concat(-100 + progress, "%, 0, 0)") : ''
      };
      var classes = Utils.classNames(className, 'progressbar', {
        'progressbar-infinite': infinite
      }, Mixins.colorClasses(props));
      return React.createElement('span', {
        ref: function ref(__reactNode) {
          _this2.__reactRefs['el'] = __reactNode;
        },
        id: id,
        style: style,
        className: classes,
        'data-progress': progress
      }, React.createElement('span', {
        style: transformStyle
      }));
    }
  }, {
    key: "refs",
    get: function get() {
      return this.__reactRefs;
    },
    set: function set(refs) {}
  }]);

  return F7Progressbar;
}(React.Component);

__reactComponentSetProps(F7Progressbar, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  progress: Number,
  infinite: Boolean
}, Mixins.colorProps));

F7Progressbar.displayName = 'f7-progressbar';
export default F7Progressbar;